import script from "./SortingGame.vue?vue&type=script&setup=true&lang=js"
export * from "./SortingGame.vue?vue&type=script&setup=true&lang=js"

import "./SortingGame.vue?vue&type=style&index=0&id=5405c7dd&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5405c7dd"]])

export default __exports__